// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aIEqbksd5iYe8yopXTKk{max-width:432px;margin-top:-8px}.RduLpz2jOI4O90Yy_os2{justify-content:space-between;margin-bottom:25px;display:flex}.RduLpz2jOI4O90Yy_os2:last-of-type{margin-bottom:0}.FEa5H6Dk5voYOe1dmCtH{align-items:center;display:flex}.FEa5H6Dk5voYOe1dmCtH:nth-of-type(2){margin-right:6px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `aIEqbksd5iYe8yopXTKk`,
	"section": `RduLpz2jOI4O90Yy_os2`,
	"box": `FEa5H6Dk5voYOe1dmCtH`
};
export default ___CSS_LOADER_EXPORT___;
